import React, { useEffect, useState } from 'react';
import { Form, FormInstance } from 'antd';

import styles from '../../index.module.scss';

interface StepProps {
  form: FormInstance<any>;
  setFrequency?: (item: boolean) => void;
}
const options = [
  { value: 'regularly', label: 'Regularly' },
  { value: 'sometimes', label: 'Sometimes' },
  { value: 'never', label: 'Never' },
];

export default function SecondStep({ form, setFrequency }: StepProps): React.ReactElement {
  const [selected, setSelected] = useState('regularly');

  useEffect(() => {
    if (selected === 'never') {
      setFrequency?.(true);
    } else {
      setFrequency?.(false);
    }
  }, [selected]);

  return (
    <Form form={form} layout="vertical">
      <h4 className={styles.title}>
        How frequently do you receive tips at your job?
      </h4>
      <Form.Item name="tipFrequency" label="" initialValue={selected}>
        <div className={styles.radioGroup}>
          {options?.map((option) => (
            <label
              key={option.value}
              className={`${styles.radioItem} ${selected === option.value ? styles.selected : ''
              }`}

            >
              <input
                type="radio"
                name="tipFrequency"
                value={option.value}
                checked={selected === option.value}
                onChange={() => setSelected(option.value)}
                className={styles.radioInput}
              />
              <span className={styles.radioCircle} />
              {option.label}
            </label>
          ))}
        </div>
      </Form.Item>
    </Form>
  );
}
